var $ = require('jquery');

var Dropdown = function Dropdown() {
	var $dropdown = $('.dropdown');
	var $menuWrap = $('.menu-wrap');

	if($dropdown.length && $menuWrap.length) {
		/** Main Dropdown Toggle **/
		var $toggle = $menuWrap.find('.toggle');
		if($toggle.length) {
			$toggle.click(function() {
				$(this).siblings('.dropdown').addClass('open');

				var $parents = $dropdown.find('.current-menu-parent');
				if($parents.length) {
					setTimeout(function() { $parents.find('i').click(); }, 500);
				}
			});
		}

		var $close = $dropdown.find('.close');
		if($close.length) {
			$close.click(function() {
				var $openSubs = $('.menu-item-has-children i.open');

				if($openSubs.length) {
					$openSubs.trigger('click', [function() {
						$close.parents('.dropdown').removeClass('open');
					}]);
				} else {
					$close.parents('.dropdown').removeClass('open');
				}
			});
		}
		/** End Main Dropdown Toggle **/

		/** Sub Menu Toggle **/
		var $subs = $dropdown.find('.menu-item-has-children');
		if($subs.length) {
			$subs.find('i').on('click', function(e, callback) {
				var $this = $(this);
				$this.toggleClass('open');

				//tot up height
				var totalHeight = 0;
				var $subMenu = $this.siblings('.sub-menu');

				$subMenu.find('li').each(function() {
					totalHeight += $(this).outerHeight(true);
				});

				$subMenu.clearQueue().animate({
					height: ($subMenu.height() === 0) ? totalHeight : 0,
					easing: 'ease-out'
				}, 300, function() {
					if(typeof callback !== 'undefined') setTimeout(callback, 200);
				});
			});
		}
		/** End Sub Menu Toggle **/
	}
}

module.exports = Dropdown;